/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexImport } from './routes/_authenticated/index'
import { Route as AuthenticatedUserActivityLogsImport } from './routes/_authenticated/user-activity-logs'
import { Route as AuthenticatedSkillsImport } from './routes/_authenticated/skills'
import { Route as AuthenticatedLaborContractsImport } from './routes/_authenticated/labor-contracts'
import { Route as AuthenticatedLaborContractGenerationImport } from './routes/_authenticated/labor-contract-generation'
import { Route as AuthenticatedLaborContractDashboardImport } from './routes/_authenticated/labor-contract-dashboard'
import { Route as AuthenticatedInsuranceDashboardImport } from './routes/_authenticated/insurance-dashboard'
import { Route as AuthenticatedEmployeeGiftsImport } from './routes/_authenticated/employee-gifts'
import { Route as AuthenticatedEmployeeAssetsDashboardImport } from './routes/_authenticated/employee-assets-dashboard'
import { Route as AuthenticatedBusinessReportImport } from './routes/_authenticated/business-report'
import { Route as AuthenticatedBusinessPlanSettingsImport } from './routes/_authenticated/business-plan-settings'
import { Route as AuthenticatedBannedEmployeesImport } from './routes/_authenticated/banned-employees'
import { Route as errors503Import } from './routes/(errors)/503'
import { Route as errors500Import } from './routes/(errors)/500'
import { Route as errors404Import } from './routes/(errors)/404'
import { Route as errors403Import } from './routes/(errors)/403'
import { Route as errors401Import } from './routes/(errors)/401'
import { Route as authSignUpImport } from './routes/(auth)/sign-up'
import { Route as authSignIn2Import } from './routes/(auth)/sign-in-2'
import { Route as authSignInImport } from './routes/(auth)/sign-in'
import { Route as authOtpImport } from './routes/(auth)/otp'
import { Route as authLocationRequiredImport } from './routes/(auth)/location-required'
import { Route as authForgotPasswordImport } from './routes/(auth)/forgot-password'
import { Route as authDangNhapImport } from './routes/(auth)/dang-nhap'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users/route'
import { Route as AuthenticatedUserSessionsRouteImport } from './routes/_authenticated/user-sessions/route'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedRolesRouteImport } from './routes/_authenticated/roles/route'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications/route'
import { Route as AuthenticatedHolidaySettingRouteImport } from './routes/_authenticated/holiday-setting/route'
import { Route as AuthenticatedFileStorageRouteImport } from './routes/_authenticated/file-storage/route'
import { Route as AuthenticatedEmployeesRouteImport } from './routes/_authenticated/employees/route'
import { Route as AuthenticatedEmployeeGroupsRouteImport } from './routes/_authenticated/employee-groups/route'
import { Route as AuthenticatedEmployeeAssetsRouteImport } from './routes/_authenticated/employee-assets/route'
import { Route as AuthenticatedCustomTagRouteImport } from './routes/_authenticated/custom-tag/route'
import { Route as AuthenticatedCompaniesRouteImport } from './routes/_authenticated/companies/route'
import { Route as AuthenticatedAssetsRouteImport } from './routes/_authenticated/assets/route'
import { Route as AuthenticatedWorkforceInsightsIndexImport } from './routes/_authenticated/workforce-insights/index'
import { Route as AuthenticatedWorkforceAnalyticsIndexImport } from './routes/_authenticated/workforce-analytics/index'
import { Route as AuthenticatedVaiTroIndexImport } from './routes/_authenticated/vai-tro/index'
import { Route as AuthenticatedUsersIndexImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedUserSessionsIndexImport } from './routes/_authenticated/user-sessions/index'
import { Route as AuthenticatedTransactionCategoryIndexImport } from './routes/_authenticated/transaction-category/index'
import { Route as AuthenticatedTimekeepingIndexImport } from './routes/_authenticated/timekeeping/index'
import { Route as AuthenticatedTasksIndexImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedSettingsIndexImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedRolesIndexImport } from './routes/_authenticated/roles/index'
import { Route as AuthenticatedRequestTicketIndexImport } from './routes/_authenticated/request-ticket/index'
import { Route as AuthenticatedProfileDashboardIndexImport } from './routes/_authenticated/profile-dashboard/index'
import { Route as AuthenticatedPayslipDashboardIndexImport } from './routes/_authenticated/payslip-dashboard/index'
import { Route as AuthenticatedNhanSuIndexImport } from './routes/_authenticated/nhan-su/index'
import { Route as AuthenticatedNhaMayIndexImport } from './routes/_authenticated/nha-may/index'
import { Route as AuthenticatedNguoiDungIndexImport } from './routes/_authenticated/nguoi-dung/index'
import { Route as AuthenticatedLeaveTrackingIndexImport } from './routes/_authenticated/leave-tracking/index'
import { Route as AuthenticatedKeToanIndexImport } from './routes/_authenticated/ke-toan/index'
import { Route as AuthenticatedHelpCenterIndexImport } from './routes/_authenticated/help-center/index'
import { Route as AuthenticatedEmployeesIndexImport } from './routes/_authenticated/employees/index'
import { Route as AuthenticatedEmployeeWalletIndexImport } from './routes/_authenticated/employee-wallet/index'
import { Route as AuthenticatedEmployeePortalIndexImport } from './routes/_authenticated/employee-portal/index'
import { Route as AuthenticatedDormitoryManagementIndexImport } from './routes/_authenticated/dormitory-management/index'
import { Route as AuthenticatedDormitoryHierachyIndexImport } from './routes/_authenticated/dormitory-hierachy/index'
import { Route as AuthenticatedDiligentEmployeesIndexImport } from './routes/_authenticated/diligent-employees/index'
import { Route as AuthenticatedDashboardIndexImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedCompaniesIndexImport } from './routes/_authenticated/companies/index'
import { Route as AuthenticatedCommissionStatisticsIndexImport } from './routes/_authenticated/commission-statistics/index'
import { Route as AuthenticatedCommissionPayslipsIndexImport } from './routes/_authenticated/commission-payslips/index'
import { Route as AuthenticatedChatsIndexImport } from './routes/_authenticated/chats/index'
import { Route as AuthenticatedBaoCaoIndexImport } from './routes/_authenticated/bao-cao/index'
import { Route as AuthenticatedAppsIndexImport } from './routes/_authenticated/apps/index'
import { Route as AuthenticatedAccountingTransactionIndexImport } from './routes/_authenticated/accounting-transaction/index'
import { Route as AuthenticatedAccountingDashboardIndexImport } from './routes/_authenticated/accounting-dashboard/index'
import { Route as AuthenticatedUserSessionsStatisticsImport } from './routes/_authenticated/user-sessions/statistics'
import { Route as AuthenticatedSettingsProfileImport } from './routes/_authenticated/settings/profile'
import { Route as AuthenticatedSettingsNotificationsImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsDisplayImport } from './routes/_authenticated/settings/display'
import { Route as AuthenticatedSettingsAppearanceImport } from './routes/_authenticated/settings/appearance'
import { Route as AuthenticatedSettingsAccountImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedEmployeePortalWalletImport } from './routes/_authenticated/employee-portal/wallet'
import { Route as AuthenticatedEmployeePortalRequestTicketsImport } from './routes/_authenticated/employee-portal/request-tickets'
import { Route as AuthenticatedEmployeePortalProfileImport } from './routes/_authenticated/employee-portal/profile'
import { Route as AuthenticatedEmployeePortalGiftsImport } from './routes/_authenticated/employee-portal/gifts'
import { Route as AuthenticatedEmployeePortalDormitoryImport } from './routes/_authenticated/employee-portal/dormitory'
import { Route as AuthenticatedEmployeePortalContractsImport } from './routes/_authenticated/employee-portal/contracts'
import { Route as AuthenticatedEmployeePortalConsumptionImport } from './routes/_authenticated/employee-portal/consumption'
import { Route as AuthenticatedEmployeePortalAttendanceImport } from './routes/_authenticated/employee-portal/attendance'
import { Route as AuthenticatedEmployeesNewRouteImport } from './routes/_authenticated/employees/new/route'
import { Route as AuthenticatedEmployeesIdRouteImport } from './routes/_authenticated/employees/$id/route'
import { Route as AuthenticatedEmployeesIdEditRouteImport } from './routes/_authenticated/employees/$id/edit/route'

// Create Virtual Routes

const AuthenticatedPayslipManagementLazyImport = createFileRoute(
  '/_authenticated/payslip-management',
)()

// Create/Update Routes

const AuthenticatedRouteRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedIndexRoute = AuthenticatedIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedPayslipManagementLazyRoute =
  AuthenticatedPayslipManagementLazyImport.update({
    id: '/payslip-management',
    path: '/payslip-management',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/payslip-management.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedUserActivityLogsRoute =
  AuthenticatedUserActivityLogsImport.update({
    id: '/user-activity-logs',
    path: '/user-activity-logs',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedSkillsRoute = AuthenticatedSkillsImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedLaborContractsRoute =
  AuthenticatedLaborContractsImport.update({
    id: '/labor-contracts',
    path: '/labor-contracts',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedLaborContractGenerationRoute =
  AuthenticatedLaborContractGenerationImport.update({
    id: '/labor-contract-generation',
    path: '/labor-contract-generation',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedLaborContractDashboardRoute =
  AuthenticatedLaborContractDashboardImport.update({
    id: '/labor-contract-dashboard',
    path: '/labor-contract-dashboard',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedInsuranceDashboardRoute =
  AuthenticatedInsuranceDashboardImport.update({
    id: '/insurance-dashboard',
    path: '/insurance-dashboard',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedEmployeeGiftsRoute = AuthenticatedEmployeeGiftsImport.update(
  {
    id: '/employee-gifts',
    path: '/employee-gifts',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any,
)

const AuthenticatedEmployeeAssetsDashboardRoute =
  AuthenticatedEmployeeAssetsDashboardImport.update({
    id: '/employee-assets-dashboard',
    path: '/employee-assets-dashboard',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedBusinessReportRoute =
  AuthenticatedBusinessReportImport.update({
    id: '/business-report',
    path: '/business-report',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedBusinessPlanSettingsRoute =
  AuthenticatedBusinessPlanSettingsImport.update({
    id: '/business-plan-settings',
    path: '/business-plan-settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedBannedEmployeesRoute =
  AuthenticatedBannedEmployeesImport.update({
    id: '/banned-employees',
    path: '/banned-employees',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const errors503Route = errors503Import.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRoute,
} as any)

const errors500Route = errors500Import.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRoute,
} as any)

const errors404Route = errors404Import.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRoute,
} as any)

const errors403Route = errors403Import.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRoute,
} as any)

const errors401Route = errors401Import.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRoute,
} as any)

const authSignUpRoute = authSignUpImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRoute,
} as any)

const authSignIn2Route = authSignIn2Import.update({
  id: '/(auth)/sign-in-2',
  path: '/sign-in-2',
  getParentRoute: () => rootRoute,
} as any)

const authSignInRoute = authSignInImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRoute,
} as any)

const authOtpRoute = authOtpImport.update({
  id: '/(auth)/otp',
  path: '/otp',
  getParentRoute: () => rootRoute,
} as any)

const authLocationRequiredRoute = authLocationRequiredImport.update({
  id: '/(auth)/location-required',
  path: '/location-required',
  getParentRoute: () => rootRoute,
} as any)

const authForgotPasswordRoute = authForgotPasswordImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const authDangNhapRoute = authDangNhapImport.update({
  id: '/(auth)/dang-nhap',
  path: '/dang-nhap',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedUsersRouteRoute = AuthenticatedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedUserSessionsRouteRoute =
  AuthenticatedUserSessionsRouteImport.update({
    id: '/user-sessions',
    path: '/user-sessions',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedSettingsRouteRoute = AuthenticatedSettingsRouteImport.update(
  {
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any,
)

const AuthenticatedRolesRouteRoute = AuthenticatedRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedNotificationsRouteRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedHolidaySettingRouteRoute =
  AuthenticatedHolidaySettingRouteImport.update({
    id: '/holiday-setting',
    path: '/holiday-setting',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedFileStorageRouteRoute =
  AuthenticatedFileStorageRouteImport.update({
    id: '/file-storage',
    path: '/file-storage',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedEmployeesRouteRoute =
  AuthenticatedEmployeesRouteImport.update({
    id: '/employees',
    path: '/employees',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedEmployeeGroupsRouteRoute =
  AuthenticatedEmployeeGroupsRouteImport.update({
    id: '/employee-groups',
    path: '/employee-groups',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedEmployeeAssetsRouteRoute =
  AuthenticatedEmployeeAssetsRouteImport.update({
    id: '/employee-assets',
    path: '/employee-assets',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedCustomTagRouteRoute =
  AuthenticatedCustomTagRouteImport.update({
    id: '/custom-tag',
    path: '/custom-tag',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedCompaniesRouteRoute =
  AuthenticatedCompaniesRouteImport.update({
    id: '/companies',
    path: '/companies',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedAssetsRouteRoute = AuthenticatedAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedWorkforceInsightsIndexRoute =
  AuthenticatedWorkforceInsightsIndexImport.update({
    id: '/workforce-insights/',
    path: '/workforce-insights/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedWorkforceAnalyticsIndexRoute =
  AuthenticatedWorkforceAnalyticsIndexImport.update({
    id: '/workforce-analytics/',
    path: '/workforce-analytics/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedVaiTroIndexRoute = AuthenticatedVaiTroIndexImport.update({
  id: '/vai-tro/',
  path: '/vai-tro/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedUsersRouteRoute,
} as any)

const AuthenticatedUserSessionsIndexRoute =
  AuthenticatedUserSessionsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedUserSessionsRouteRoute,
  } as any)

const AuthenticatedTransactionCategoryIndexRoute =
  AuthenticatedTransactionCategoryIndexImport.update({
    id: '/transaction-category/',
    path: '/transaction-category/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedTimekeepingIndexRoute =
  AuthenticatedTimekeepingIndexImport.update({
    id: '/timekeeping/',
    path: '/timekeeping/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedSettingsIndexRoute = AuthenticatedSettingsIndexImport.update(
  {
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any,
)

const AuthenticatedRolesIndexRoute = AuthenticatedRolesIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRolesRouteRoute,
} as any)

const AuthenticatedRequestTicketIndexRoute =
  AuthenticatedRequestTicketIndexImport.update({
    id: '/request-ticket/',
    path: '/request-ticket/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedProfileDashboardIndexRoute =
  AuthenticatedProfileDashboardIndexImport.update({
    id: '/profile-dashboard/',
    path: '/profile-dashboard/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedPayslipDashboardIndexRoute =
  AuthenticatedPayslipDashboardIndexImport.update({
    id: '/payslip-dashboard/',
    path: '/payslip-dashboard/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedNhanSuIndexRoute = AuthenticatedNhanSuIndexImport.update({
  id: '/nhan-su/',
  path: '/nhan-su/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedNhaMayIndexRoute = AuthenticatedNhaMayIndexImport.update({
  id: '/nha-may/',
  path: '/nha-may/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedNguoiDungIndexRoute =
  AuthenticatedNguoiDungIndexImport.update({
    id: '/nguoi-dung/',
    path: '/nguoi-dung/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedLeaveTrackingIndexRoute =
  AuthenticatedLeaveTrackingIndexImport.update({
    id: '/leave-tracking/',
    path: '/leave-tracking/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedKeToanIndexRoute = AuthenticatedKeToanIndexImport.update({
  id: '/ke-toan/',
  path: '/ke-toan/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedHelpCenterIndexRoute =
  AuthenticatedHelpCenterIndexImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedEmployeesIndexRoute =
  AuthenticatedEmployeesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedEmployeesRouteRoute,
  } as any)

const AuthenticatedEmployeeWalletIndexRoute =
  AuthenticatedEmployeeWalletIndexImport.update({
    id: '/employee-wallet/',
    path: '/employee-wallet/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedEmployeePortalIndexRoute =
  AuthenticatedEmployeePortalIndexImport.update({
    id: '/employee-portal/',
    path: '/employee-portal/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedDormitoryManagementIndexRoute =
  AuthenticatedDormitoryManagementIndexImport.update({
    id: '/dormitory-management/',
    path: '/dormitory-management/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedDormitoryHierachyIndexRoute =
  AuthenticatedDormitoryHierachyIndexImport.update({
    id: '/dormitory-hierachy/',
    path: '/dormitory-hierachy/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedDiligentEmployeesIndexRoute =
  AuthenticatedDiligentEmployeesIndexImport.update({
    id: '/diligent-employees/',
    path: '/diligent-employees/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedCompaniesIndexRoute =
  AuthenticatedCompaniesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCompaniesRouteRoute,
  } as any)

const AuthenticatedCommissionStatisticsIndexRoute =
  AuthenticatedCommissionStatisticsIndexImport.update({
    id: '/commission-statistics/',
    path: '/commission-statistics/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedCommissionPayslipsIndexRoute =
  AuthenticatedCommissionPayslipsIndexImport.update({
    id: '/commission-payslips/',
    path: '/commission-payslips/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedChatsIndexRoute = AuthenticatedChatsIndexImport.update({
  id: '/chats/',
  path: '/chats/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedBaoCaoIndexRoute = AuthenticatedBaoCaoIndexImport.update({
  id: '/bao-cao/',
  path: '/bao-cao/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedAppsIndexRoute = AuthenticatedAppsIndexImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedAccountingTransactionIndexRoute =
  AuthenticatedAccountingTransactionIndexImport.update({
    id: '/accounting-transaction/',
    path: '/accounting-transaction/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedAccountingDashboardIndexRoute =
  AuthenticatedAccountingDashboardIndexImport.update({
    id: '/accounting-dashboard/',
    path: '/accounting-dashboard/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedUserSessionsStatisticsRoute =
  AuthenticatedUserSessionsStatisticsImport.update({
    id: '/statistics',
    path: '/statistics',
    getParentRoute: () => AuthenticatedUserSessionsRouteRoute,
  } as any)

const AuthenticatedSettingsProfileRoute =
  AuthenticatedSettingsProfileImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)

const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)

const AuthenticatedSettingsDisplayRoute =
  AuthenticatedSettingsDisplayImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)

const AuthenticatedSettingsAppearanceRoute =
  AuthenticatedSettingsAppearanceImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)

const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)

const AuthenticatedEmployeePortalWalletRoute =
  AuthenticatedEmployeePortalWalletImport.update({
    id: '/employee-portal/wallet',
    path: '/employee-portal/wallet',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedEmployeePortalRequestTicketsRoute =
  AuthenticatedEmployeePortalRequestTicketsImport.update({
    id: '/employee-portal/request-tickets',
    path: '/employee-portal/request-tickets',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedEmployeePortalProfileRoute =
  AuthenticatedEmployeePortalProfileImport.update({
    id: '/employee-portal/profile',
    path: '/employee-portal/profile',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedEmployeePortalGiftsRoute =
  AuthenticatedEmployeePortalGiftsImport.update({
    id: '/employee-portal/gifts',
    path: '/employee-portal/gifts',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedEmployeePortalDormitoryRoute =
  AuthenticatedEmployeePortalDormitoryImport.update({
    id: '/employee-portal/dormitory',
    path: '/employee-portal/dormitory',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedEmployeePortalContractsRoute =
  AuthenticatedEmployeePortalContractsImport.update({
    id: '/employee-portal/contracts',
    path: '/employee-portal/contracts',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedEmployeePortalConsumptionRoute =
  AuthenticatedEmployeePortalConsumptionImport.update({
    id: '/employee-portal/consumption',
    path: '/employee-portal/consumption',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedEmployeePortalAttendanceRoute =
  AuthenticatedEmployeePortalAttendanceImport.update({
    id: '/employee-portal/attendance',
    path: '/employee-portal/attendance',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedEmployeesNewRouteRoute =
  AuthenticatedEmployeesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedEmployeesRouteRoute,
  } as any)

const AuthenticatedEmployeesIdRouteRoute =
  AuthenticatedEmployeesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedEmployeesRouteRoute,
  } as any)

const AuthenticatedEmployeesIdEditRouteRoute =
  AuthenticatedEmployeesIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedEmployeesIdRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/assets': {
      id: '/_authenticated/assets'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof AuthenticatedAssetsRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/companies': {
      id: '/_authenticated/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof AuthenticatedCompaniesRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/custom-tag': {
      id: '/_authenticated/custom-tag'
      path: '/custom-tag'
      fullPath: '/custom-tag'
      preLoaderRoute: typeof AuthenticatedCustomTagRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/employee-assets': {
      id: '/_authenticated/employee-assets'
      path: '/employee-assets'
      fullPath: '/employee-assets'
      preLoaderRoute: typeof AuthenticatedEmployeeAssetsRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/employee-groups': {
      id: '/_authenticated/employee-groups'
      path: '/employee-groups'
      fullPath: '/employee-groups'
      preLoaderRoute: typeof AuthenticatedEmployeeGroupsRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/employees': {
      id: '/_authenticated/employees'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof AuthenticatedEmployeesRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/file-storage': {
      id: '/_authenticated/file-storage'
      path: '/file-storage'
      fullPath: '/file-storage'
      preLoaderRoute: typeof AuthenticatedFileStorageRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/holiday-setting': {
      id: '/_authenticated/holiday-setting'
      path: '/holiday-setting'
      fullPath: '/holiday-setting'
      preLoaderRoute: typeof AuthenticatedHolidaySettingRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/roles': {
      id: '/_authenticated/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof AuthenticatedRolesRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/user-sessions': {
      id: '/_authenticated/user-sessions'
      path: '/user-sessions'
      fullPath: '/user-sessions'
      preLoaderRoute: typeof AuthenticatedUserSessionsRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/(auth)/dang-nhap': {
      id: '/(auth)/dang-nhap'
      path: '/dang-nhap'
      fullPath: '/dang-nhap'
      preLoaderRoute: typeof authDangNhapImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/location-required': {
      id: '/(auth)/location-required'
      path: '/location-required'
      fullPath: '/location-required'
      preLoaderRoute: typeof authLocationRequiredImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/sign-in-2': {
      id: '/(auth)/sign-in-2'
      path: '/sign-in-2'
      fullPath: '/sign-in-2'
      preLoaderRoute: typeof authSignIn2Import
      parentRoute: typeof rootRoute
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpImport
      parentRoute: typeof rootRoute
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401Import
      parentRoute: typeof rootRoute
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403Import
      parentRoute: typeof rootRoute
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404Import
      parentRoute: typeof rootRoute
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500Import
      parentRoute: typeof rootRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503Import
      parentRoute: typeof rootRoute
    }
    '/_authenticated/banned-employees': {
      id: '/_authenticated/banned-employees'
      path: '/banned-employees'
      fullPath: '/banned-employees'
      preLoaderRoute: typeof AuthenticatedBannedEmployeesImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/business-plan-settings': {
      id: '/_authenticated/business-plan-settings'
      path: '/business-plan-settings'
      fullPath: '/business-plan-settings'
      preLoaderRoute: typeof AuthenticatedBusinessPlanSettingsImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/business-report': {
      id: '/_authenticated/business-report'
      path: '/business-report'
      fullPath: '/business-report'
      preLoaderRoute: typeof AuthenticatedBusinessReportImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/employee-assets-dashboard': {
      id: '/_authenticated/employee-assets-dashboard'
      path: '/employee-assets-dashboard'
      fullPath: '/employee-assets-dashboard'
      preLoaderRoute: typeof AuthenticatedEmployeeAssetsDashboardImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/employee-gifts': {
      id: '/_authenticated/employee-gifts'
      path: '/employee-gifts'
      fullPath: '/employee-gifts'
      preLoaderRoute: typeof AuthenticatedEmployeeGiftsImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/insurance-dashboard': {
      id: '/_authenticated/insurance-dashboard'
      path: '/insurance-dashboard'
      fullPath: '/insurance-dashboard'
      preLoaderRoute: typeof AuthenticatedInsuranceDashboardImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/labor-contract-dashboard': {
      id: '/_authenticated/labor-contract-dashboard'
      path: '/labor-contract-dashboard'
      fullPath: '/labor-contract-dashboard'
      preLoaderRoute: typeof AuthenticatedLaborContractDashboardImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/labor-contract-generation': {
      id: '/_authenticated/labor-contract-generation'
      path: '/labor-contract-generation'
      fullPath: '/labor-contract-generation'
      preLoaderRoute: typeof AuthenticatedLaborContractGenerationImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/labor-contracts': {
      id: '/_authenticated/labor-contracts'
      path: '/labor-contracts'
      fullPath: '/labor-contracts'
      preLoaderRoute: typeof AuthenticatedLaborContractsImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/skills': {
      id: '/_authenticated/skills'
      path: '/skills'
      fullPath: '/skills'
      preLoaderRoute: typeof AuthenticatedSkillsImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/user-activity-logs': {
      id: '/_authenticated/user-activity-logs'
      path: '/user-activity-logs'
      fullPath: '/user-activity-logs'
      preLoaderRoute: typeof AuthenticatedUserActivityLogsImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/payslip-management': {
      id: '/_authenticated/payslip-management'
      path: '/payslip-management'
      fullPath: '/payslip-management'
      preLoaderRoute: typeof AuthenticatedPayslipManagementLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/employees/$id': {
      id: '/_authenticated/employees/$id'
      path: '/$id'
      fullPath: '/employees/$id'
      preLoaderRoute: typeof AuthenticatedEmployeesIdRouteImport
      parentRoute: typeof AuthenticatedEmployeesRouteImport
    }
    '/_authenticated/employees/new': {
      id: '/_authenticated/employees/new'
      path: '/new'
      fullPath: '/employees/new'
      preLoaderRoute: typeof AuthenticatedEmployeesNewRouteImport
      parentRoute: typeof AuthenticatedEmployeesRouteImport
    }
    '/_authenticated/employee-portal/attendance': {
      id: '/_authenticated/employee-portal/attendance'
      path: '/employee-portal/attendance'
      fullPath: '/employee-portal/attendance'
      preLoaderRoute: typeof AuthenticatedEmployeePortalAttendanceImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/employee-portal/consumption': {
      id: '/_authenticated/employee-portal/consumption'
      path: '/employee-portal/consumption'
      fullPath: '/employee-portal/consumption'
      preLoaderRoute: typeof AuthenticatedEmployeePortalConsumptionImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/employee-portal/contracts': {
      id: '/_authenticated/employee-portal/contracts'
      path: '/employee-portal/contracts'
      fullPath: '/employee-portal/contracts'
      preLoaderRoute: typeof AuthenticatedEmployeePortalContractsImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/employee-portal/dormitory': {
      id: '/_authenticated/employee-portal/dormitory'
      path: '/employee-portal/dormitory'
      fullPath: '/employee-portal/dormitory'
      preLoaderRoute: typeof AuthenticatedEmployeePortalDormitoryImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/employee-portal/gifts': {
      id: '/_authenticated/employee-portal/gifts'
      path: '/employee-portal/gifts'
      fullPath: '/employee-portal/gifts'
      preLoaderRoute: typeof AuthenticatedEmployeePortalGiftsImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/employee-portal/profile': {
      id: '/_authenticated/employee-portal/profile'
      path: '/employee-portal/profile'
      fullPath: '/employee-portal/profile'
      preLoaderRoute: typeof AuthenticatedEmployeePortalProfileImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/employee-portal/request-tickets': {
      id: '/_authenticated/employee-portal/request-tickets'
      path: '/employee-portal/request-tickets'
      fullPath: '/employee-portal/request-tickets'
      preLoaderRoute: typeof AuthenticatedEmployeePortalRequestTicketsImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/employee-portal/wallet': {
      id: '/_authenticated/employee-portal/wallet'
      path: '/employee-portal/wallet'
      fullPath: '/employee-portal/wallet'
      preLoaderRoute: typeof AuthenticatedEmployeePortalWalletImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountImport
      parentRoute: typeof AuthenticatedSettingsRouteImport
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceImport
      parentRoute: typeof AuthenticatedSettingsRouteImport
    }
    '/_authenticated/settings/display': {
      id: '/_authenticated/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSettingsDisplayImport
      parentRoute: typeof AuthenticatedSettingsRouteImport
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsImport
      parentRoute: typeof AuthenticatedSettingsRouteImport
    }
    '/_authenticated/settings/profile': {
      id: '/_authenticated/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedSettingsProfileImport
      parentRoute: typeof AuthenticatedSettingsRouteImport
    }
    '/_authenticated/user-sessions/statistics': {
      id: '/_authenticated/user-sessions/statistics'
      path: '/statistics'
      fullPath: '/user-sessions/statistics'
      preLoaderRoute: typeof AuthenticatedUserSessionsStatisticsImport
      parentRoute: typeof AuthenticatedUserSessionsRouteImport
    }
    '/_authenticated/accounting-dashboard/': {
      id: '/_authenticated/accounting-dashboard/'
      path: '/accounting-dashboard'
      fullPath: '/accounting-dashboard'
      preLoaderRoute: typeof AuthenticatedAccountingDashboardIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/accounting-transaction/': {
      id: '/_authenticated/accounting-transaction/'
      path: '/accounting-transaction'
      fullPath: '/accounting-transaction'
      preLoaderRoute: typeof AuthenticatedAccountingTransactionIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/apps/': {
      id: '/_authenticated/apps/'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AuthenticatedAppsIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/bao-cao/': {
      id: '/_authenticated/bao-cao/'
      path: '/bao-cao'
      fullPath: '/bao-cao'
      preLoaderRoute: typeof AuthenticatedBaoCaoIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/chats/': {
      id: '/_authenticated/chats/'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof AuthenticatedChatsIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/commission-payslips/': {
      id: '/_authenticated/commission-payslips/'
      path: '/commission-payslips'
      fullPath: '/commission-payslips'
      preLoaderRoute: typeof AuthenticatedCommissionPayslipsIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/commission-statistics/': {
      id: '/_authenticated/commission-statistics/'
      path: '/commission-statistics'
      fullPath: '/commission-statistics'
      preLoaderRoute: typeof AuthenticatedCommissionStatisticsIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/companies/': {
      id: '/_authenticated/companies/'
      path: '/'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthenticatedCompaniesIndexImport
      parentRoute: typeof AuthenticatedCompaniesRouteImport
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/diligent-employees/': {
      id: '/_authenticated/diligent-employees/'
      path: '/diligent-employees'
      fullPath: '/diligent-employees'
      preLoaderRoute: typeof AuthenticatedDiligentEmployeesIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/dormitory-hierachy/': {
      id: '/_authenticated/dormitory-hierachy/'
      path: '/dormitory-hierachy'
      fullPath: '/dormitory-hierachy'
      preLoaderRoute: typeof AuthenticatedDormitoryHierachyIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/dormitory-management/': {
      id: '/_authenticated/dormitory-management/'
      path: '/dormitory-management'
      fullPath: '/dormitory-management'
      preLoaderRoute: typeof AuthenticatedDormitoryManagementIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/employee-portal/': {
      id: '/_authenticated/employee-portal/'
      path: '/employee-portal'
      fullPath: '/employee-portal'
      preLoaderRoute: typeof AuthenticatedEmployeePortalIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/employee-wallet/': {
      id: '/_authenticated/employee-wallet/'
      path: '/employee-wallet'
      fullPath: '/employee-wallet'
      preLoaderRoute: typeof AuthenticatedEmployeeWalletIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/employees/': {
      id: '/_authenticated/employees/'
      path: '/'
      fullPath: '/employees/'
      preLoaderRoute: typeof AuthenticatedEmployeesIndexImport
      parentRoute: typeof AuthenticatedEmployeesRouteImport
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/ke-toan/': {
      id: '/_authenticated/ke-toan/'
      path: '/ke-toan'
      fullPath: '/ke-toan'
      preLoaderRoute: typeof AuthenticatedKeToanIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/leave-tracking/': {
      id: '/_authenticated/leave-tracking/'
      path: '/leave-tracking'
      fullPath: '/leave-tracking'
      preLoaderRoute: typeof AuthenticatedLeaveTrackingIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/nguoi-dung/': {
      id: '/_authenticated/nguoi-dung/'
      path: '/nguoi-dung'
      fullPath: '/nguoi-dung'
      preLoaderRoute: typeof AuthenticatedNguoiDungIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/nha-may/': {
      id: '/_authenticated/nha-may/'
      path: '/nha-may'
      fullPath: '/nha-may'
      preLoaderRoute: typeof AuthenticatedNhaMayIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/nhan-su/': {
      id: '/_authenticated/nhan-su/'
      path: '/nhan-su'
      fullPath: '/nhan-su'
      preLoaderRoute: typeof AuthenticatedNhanSuIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/payslip-dashboard/': {
      id: '/_authenticated/payslip-dashboard/'
      path: '/payslip-dashboard'
      fullPath: '/payslip-dashboard'
      preLoaderRoute: typeof AuthenticatedPayslipDashboardIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/profile-dashboard/': {
      id: '/_authenticated/profile-dashboard/'
      path: '/profile-dashboard'
      fullPath: '/profile-dashboard'
      preLoaderRoute: typeof AuthenticatedProfileDashboardIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/request-ticket/': {
      id: '/_authenticated/request-ticket/'
      path: '/request-ticket'
      fullPath: '/request-ticket'
      preLoaderRoute: typeof AuthenticatedRequestTicketIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/roles/': {
      id: '/_authenticated/roles/'
      path: '/'
      fullPath: '/roles/'
      preLoaderRoute: typeof AuthenticatedRolesIndexImport
      parentRoute: typeof AuthenticatedRolesRouteImport
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexImport
      parentRoute: typeof AuthenticatedSettingsRouteImport
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthenticatedTasksIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/timekeeping/': {
      id: '/_authenticated/timekeeping/'
      path: '/timekeeping'
      fullPath: '/timekeeping'
      preLoaderRoute: typeof AuthenticatedTimekeepingIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/transaction-category/': {
      id: '/_authenticated/transaction-category/'
      path: '/transaction-category'
      fullPath: '/transaction-category'
      preLoaderRoute: typeof AuthenticatedTransactionCategoryIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/user-sessions/': {
      id: '/_authenticated/user-sessions/'
      path: '/'
      fullPath: '/user-sessions/'
      preLoaderRoute: typeof AuthenticatedUserSessionsIndexImport
      parentRoute: typeof AuthenticatedUserSessionsRouteImport
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexImport
      parentRoute: typeof AuthenticatedUsersRouteImport
    }
    '/_authenticated/vai-tro/': {
      id: '/_authenticated/vai-tro/'
      path: '/vai-tro'
      fullPath: '/vai-tro'
      preLoaderRoute: typeof AuthenticatedVaiTroIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/workforce-analytics/': {
      id: '/_authenticated/workforce-analytics/'
      path: '/workforce-analytics'
      fullPath: '/workforce-analytics'
      preLoaderRoute: typeof AuthenticatedWorkforceAnalyticsIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/workforce-insights/': {
      id: '/_authenticated/workforce-insights/'
      path: '/workforce-insights'
      fullPath: '/workforce-insights'
      preLoaderRoute: typeof AuthenticatedWorkforceInsightsIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/employees/$id/edit': {
      id: '/_authenticated/employees/$id/edit'
      path: '/edit'
      fullPath: '/employees/$id/edit'
      preLoaderRoute: typeof AuthenticatedEmployeesIdEditRouteImport
      parentRoute: typeof AuthenticatedEmployeesIdRouteImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedCompaniesRouteRouteChildren {
  AuthenticatedCompaniesIndexRoute: typeof AuthenticatedCompaniesIndexRoute
}

const AuthenticatedCompaniesRouteRouteChildren: AuthenticatedCompaniesRouteRouteChildren =
  {
    AuthenticatedCompaniesIndexRoute: AuthenticatedCompaniesIndexRoute,
  }

const AuthenticatedCompaniesRouteRouteWithChildren =
  AuthenticatedCompaniesRouteRoute._addFileChildren(
    AuthenticatedCompaniesRouteRouteChildren,
  )

interface AuthenticatedEmployeesIdRouteRouteChildren {
  AuthenticatedEmployeesIdEditRouteRoute: typeof AuthenticatedEmployeesIdEditRouteRoute
}

const AuthenticatedEmployeesIdRouteRouteChildren: AuthenticatedEmployeesIdRouteRouteChildren =
  {
    AuthenticatedEmployeesIdEditRouteRoute:
      AuthenticatedEmployeesIdEditRouteRoute,
  }

const AuthenticatedEmployeesIdRouteRouteWithChildren =
  AuthenticatedEmployeesIdRouteRoute._addFileChildren(
    AuthenticatedEmployeesIdRouteRouteChildren,
  )

interface AuthenticatedEmployeesRouteRouteChildren {
  AuthenticatedEmployeesIdRouteRoute: typeof AuthenticatedEmployeesIdRouteRouteWithChildren
  AuthenticatedEmployeesNewRouteRoute: typeof AuthenticatedEmployeesNewRouteRoute
  AuthenticatedEmployeesIndexRoute: typeof AuthenticatedEmployeesIndexRoute
}

const AuthenticatedEmployeesRouteRouteChildren: AuthenticatedEmployeesRouteRouteChildren =
  {
    AuthenticatedEmployeesIdRouteRoute:
      AuthenticatedEmployeesIdRouteRouteWithChildren,
    AuthenticatedEmployeesNewRouteRoute: AuthenticatedEmployeesNewRouteRoute,
    AuthenticatedEmployeesIndexRoute: AuthenticatedEmployeesIndexRoute,
  }

const AuthenticatedEmployeesRouteRouteWithChildren =
  AuthenticatedEmployeesRouteRoute._addFileChildren(
    AuthenticatedEmployeesRouteRouteChildren,
  )

interface AuthenticatedRolesRouteRouteChildren {
  AuthenticatedRolesIndexRoute: typeof AuthenticatedRolesIndexRoute
}

const AuthenticatedRolesRouteRouteChildren: AuthenticatedRolesRouteRouteChildren =
  {
    AuthenticatedRolesIndexRoute: AuthenticatedRolesIndexRoute,
  }

const AuthenticatedRolesRouteRouteWithChildren =
  AuthenticatedRolesRouteRoute._addFileChildren(
    AuthenticatedRolesRouteRouteChildren,
  )

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsAppearanceRoute: typeof AuthenticatedSettingsAppearanceRoute
  AuthenticatedSettingsDisplayRoute: typeof AuthenticatedSettingsDisplayRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsProfileRoute: typeof AuthenticatedSettingsProfileRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
    AuthenticatedSettingsAppearanceRoute: AuthenticatedSettingsAppearanceRoute,
    AuthenticatedSettingsDisplayRoute: AuthenticatedSettingsDisplayRoute,
    AuthenticatedSettingsNotificationsRoute:
      AuthenticatedSettingsNotificationsRoute,
    AuthenticatedSettingsProfileRoute: AuthenticatedSettingsProfileRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedUserSessionsRouteRouteChildren {
  AuthenticatedUserSessionsStatisticsRoute: typeof AuthenticatedUserSessionsStatisticsRoute
  AuthenticatedUserSessionsIndexRoute: typeof AuthenticatedUserSessionsIndexRoute
}

const AuthenticatedUserSessionsRouteRouteChildren: AuthenticatedUserSessionsRouteRouteChildren =
  {
    AuthenticatedUserSessionsStatisticsRoute:
      AuthenticatedUserSessionsStatisticsRoute,
    AuthenticatedUserSessionsIndexRoute: AuthenticatedUserSessionsIndexRoute,
  }

const AuthenticatedUserSessionsRouteRouteWithChildren =
  AuthenticatedUserSessionsRouteRoute._addFileChildren(
    AuthenticatedUserSessionsRouteRouteChildren,
  )

interface AuthenticatedUsersRouteRouteChildren {
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
}

const AuthenticatedUsersRouteRouteChildren: AuthenticatedUsersRouteRouteChildren =
  {
    AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  }

const AuthenticatedUsersRouteRouteWithChildren =
  AuthenticatedUsersRouteRoute._addFileChildren(
    AuthenticatedUsersRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAssetsRouteRoute: typeof AuthenticatedAssetsRouteRoute
  AuthenticatedCompaniesRouteRoute: typeof AuthenticatedCompaniesRouteRouteWithChildren
  AuthenticatedCustomTagRouteRoute: typeof AuthenticatedCustomTagRouteRoute
  AuthenticatedEmployeeAssetsRouteRoute: typeof AuthenticatedEmployeeAssetsRouteRoute
  AuthenticatedEmployeeGroupsRouteRoute: typeof AuthenticatedEmployeeGroupsRouteRoute
  AuthenticatedEmployeesRouteRoute: typeof AuthenticatedEmployeesRouteRouteWithChildren
  AuthenticatedFileStorageRouteRoute: typeof AuthenticatedFileStorageRouteRoute
  AuthenticatedHolidaySettingRouteRoute: typeof AuthenticatedHolidaySettingRouteRoute
  AuthenticatedNotificationsRouteRoute: typeof AuthenticatedNotificationsRouteRoute
  AuthenticatedRolesRouteRoute: typeof AuthenticatedRolesRouteRouteWithChildren
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedUserSessionsRouteRoute: typeof AuthenticatedUserSessionsRouteRouteWithChildren
  AuthenticatedUsersRouteRoute: typeof AuthenticatedUsersRouteRouteWithChildren
  AuthenticatedBannedEmployeesRoute: typeof AuthenticatedBannedEmployeesRoute
  AuthenticatedBusinessPlanSettingsRoute: typeof AuthenticatedBusinessPlanSettingsRoute
  AuthenticatedBusinessReportRoute: typeof AuthenticatedBusinessReportRoute
  AuthenticatedEmployeeAssetsDashboardRoute: typeof AuthenticatedEmployeeAssetsDashboardRoute
  AuthenticatedEmployeeGiftsRoute: typeof AuthenticatedEmployeeGiftsRoute
  AuthenticatedInsuranceDashboardRoute: typeof AuthenticatedInsuranceDashboardRoute
  AuthenticatedLaborContractDashboardRoute: typeof AuthenticatedLaborContractDashboardRoute
  AuthenticatedLaborContractGenerationRoute: typeof AuthenticatedLaborContractGenerationRoute
  AuthenticatedLaborContractsRoute: typeof AuthenticatedLaborContractsRoute
  AuthenticatedSkillsRoute: typeof AuthenticatedSkillsRoute
  AuthenticatedUserActivityLogsRoute: typeof AuthenticatedUserActivityLogsRoute
  AuthenticatedPayslipManagementLazyRoute: typeof AuthenticatedPayslipManagementLazyRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedEmployeePortalAttendanceRoute: typeof AuthenticatedEmployeePortalAttendanceRoute
  AuthenticatedEmployeePortalConsumptionRoute: typeof AuthenticatedEmployeePortalConsumptionRoute
  AuthenticatedEmployeePortalContractsRoute: typeof AuthenticatedEmployeePortalContractsRoute
  AuthenticatedEmployeePortalDormitoryRoute: typeof AuthenticatedEmployeePortalDormitoryRoute
  AuthenticatedEmployeePortalGiftsRoute: typeof AuthenticatedEmployeePortalGiftsRoute
  AuthenticatedEmployeePortalProfileRoute: typeof AuthenticatedEmployeePortalProfileRoute
  AuthenticatedEmployeePortalRequestTicketsRoute: typeof AuthenticatedEmployeePortalRequestTicketsRoute
  AuthenticatedEmployeePortalWalletRoute: typeof AuthenticatedEmployeePortalWalletRoute
  AuthenticatedAccountingDashboardIndexRoute: typeof AuthenticatedAccountingDashboardIndexRoute
  AuthenticatedAccountingTransactionIndexRoute: typeof AuthenticatedAccountingTransactionIndexRoute
  AuthenticatedAppsIndexRoute: typeof AuthenticatedAppsIndexRoute
  AuthenticatedBaoCaoIndexRoute: typeof AuthenticatedBaoCaoIndexRoute
  AuthenticatedChatsIndexRoute: typeof AuthenticatedChatsIndexRoute
  AuthenticatedCommissionPayslipsIndexRoute: typeof AuthenticatedCommissionPayslipsIndexRoute
  AuthenticatedCommissionStatisticsIndexRoute: typeof AuthenticatedCommissionStatisticsIndexRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedDiligentEmployeesIndexRoute: typeof AuthenticatedDiligentEmployeesIndexRoute
  AuthenticatedDormitoryHierachyIndexRoute: typeof AuthenticatedDormitoryHierachyIndexRoute
  AuthenticatedDormitoryManagementIndexRoute: typeof AuthenticatedDormitoryManagementIndexRoute
  AuthenticatedEmployeePortalIndexRoute: typeof AuthenticatedEmployeePortalIndexRoute
  AuthenticatedEmployeeWalletIndexRoute: typeof AuthenticatedEmployeeWalletIndexRoute
  AuthenticatedHelpCenterIndexRoute: typeof AuthenticatedHelpCenterIndexRoute
  AuthenticatedKeToanIndexRoute: typeof AuthenticatedKeToanIndexRoute
  AuthenticatedLeaveTrackingIndexRoute: typeof AuthenticatedLeaveTrackingIndexRoute
  AuthenticatedNguoiDungIndexRoute: typeof AuthenticatedNguoiDungIndexRoute
  AuthenticatedNhaMayIndexRoute: typeof AuthenticatedNhaMayIndexRoute
  AuthenticatedNhanSuIndexRoute: typeof AuthenticatedNhanSuIndexRoute
  AuthenticatedPayslipDashboardIndexRoute: typeof AuthenticatedPayslipDashboardIndexRoute
  AuthenticatedProfileDashboardIndexRoute: typeof AuthenticatedProfileDashboardIndexRoute
  AuthenticatedRequestTicketIndexRoute: typeof AuthenticatedRequestTicketIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedTimekeepingIndexRoute: typeof AuthenticatedTimekeepingIndexRoute
  AuthenticatedTransactionCategoryIndexRoute: typeof AuthenticatedTransactionCategoryIndexRoute
  AuthenticatedVaiTroIndexRoute: typeof AuthenticatedVaiTroIndexRoute
  AuthenticatedWorkforceAnalyticsIndexRoute: typeof AuthenticatedWorkforceAnalyticsIndexRoute
  AuthenticatedWorkforceInsightsIndexRoute: typeof AuthenticatedWorkforceInsightsIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAssetsRouteRoute: AuthenticatedAssetsRouteRoute,
  AuthenticatedCompaniesRouteRoute:
    AuthenticatedCompaniesRouteRouteWithChildren,
  AuthenticatedCustomTagRouteRoute: AuthenticatedCustomTagRouteRoute,
  AuthenticatedEmployeeAssetsRouteRoute: AuthenticatedEmployeeAssetsRouteRoute,
  AuthenticatedEmployeeGroupsRouteRoute: AuthenticatedEmployeeGroupsRouteRoute,
  AuthenticatedEmployeesRouteRoute:
    AuthenticatedEmployeesRouteRouteWithChildren,
  AuthenticatedFileStorageRouteRoute: AuthenticatedFileStorageRouteRoute,
  AuthenticatedHolidaySettingRouteRoute: AuthenticatedHolidaySettingRouteRoute,
  AuthenticatedNotificationsRouteRoute: AuthenticatedNotificationsRouteRoute,
  AuthenticatedRolesRouteRoute: AuthenticatedRolesRouteRouteWithChildren,
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedUserSessionsRouteRoute:
    AuthenticatedUserSessionsRouteRouteWithChildren,
  AuthenticatedUsersRouteRoute: AuthenticatedUsersRouteRouteWithChildren,
  AuthenticatedBannedEmployeesRoute: AuthenticatedBannedEmployeesRoute,
  AuthenticatedBusinessPlanSettingsRoute:
    AuthenticatedBusinessPlanSettingsRoute,
  AuthenticatedBusinessReportRoute: AuthenticatedBusinessReportRoute,
  AuthenticatedEmployeeAssetsDashboardRoute:
    AuthenticatedEmployeeAssetsDashboardRoute,
  AuthenticatedEmployeeGiftsRoute: AuthenticatedEmployeeGiftsRoute,
  AuthenticatedInsuranceDashboardRoute: AuthenticatedInsuranceDashboardRoute,
  AuthenticatedLaborContractDashboardRoute:
    AuthenticatedLaborContractDashboardRoute,
  AuthenticatedLaborContractGenerationRoute:
    AuthenticatedLaborContractGenerationRoute,
  AuthenticatedLaborContractsRoute: AuthenticatedLaborContractsRoute,
  AuthenticatedSkillsRoute: AuthenticatedSkillsRoute,
  AuthenticatedUserActivityLogsRoute: AuthenticatedUserActivityLogsRoute,
  AuthenticatedPayslipManagementLazyRoute:
    AuthenticatedPayslipManagementLazyRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedEmployeePortalAttendanceRoute:
    AuthenticatedEmployeePortalAttendanceRoute,
  AuthenticatedEmployeePortalConsumptionRoute:
    AuthenticatedEmployeePortalConsumptionRoute,
  AuthenticatedEmployeePortalContractsRoute:
    AuthenticatedEmployeePortalContractsRoute,
  AuthenticatedEmployeePortalDormitoryRoute:
    AuthenticatedEmployeePortalDormitoryRoute,
  AuthenticatedEmployeePortalGiftsRoute: AuthenticatedEmployeePortalGiftsRoute,
  AuthenticatedEmployeePortalProfileRoute:
    AuthenticatedEmployeePortalProfileRoute,
  AuthenticatedEmployeePortalRequestTicketsRoute:
    AuthenticatedEmployeePortalRequestTicketsRoute,
  AuthenticatedEmployeePortalWalletRoute:
    AuthenticatedEmployeePortalWalletRoute,
  AuthenticatedAccountingDashboardIndexRoute:
    AuthenticatedAccountingDashboardIndexRoute,
  AuthenticatedAccountingTransactionIndexRoute:
    AuthenticatedAccountingTransactionIndexRoute,
  AuthenticatedAppsIndexRoute: AuthenticatedAppsIndexRoute,
  AuthenticatedBaoCaoIndexRoute: AuthenticatedBaoCaoIndexRoute,
  AuthenticatedChatsIndexRoute: AuthenticatedChatsIndexRoute,
  AuthenticatedCommissionPayslipsIndexRoute:
    AuthenticatedCommissionPayslipsIndexRoute,
  AuthenticatedCommissionStatisticsIndexRoute:
    AuthenticatedCommissionStatisticsIndexRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedDiligentEmployeesIndexRoute:
    AuthenticatedDiligentEmployeesIndexRoute,
  AuthenticatedDormitoryHierachyIndexRoute:
    AuthenticatedDormitoryHierachyIndexRoute,
  AuthenticatedDormitoryManagementIndexRoute:
    AuthenticatedDormitoryManagementIndexRoute,
  AuthenticatedEmployeePortalIndexRoute: AuthenticatedEmployeePortalIndexRoute,
  AuthenticatedEmployeeWalletIndexRoute: AuthenticatedEmployeeWalletIndexRoute,
  AuthenticatedHelpCenterIndexRoute: AuthenticatedHelpCenterIndexRoute,
  AuthenticatedKeToanIndexRoute: AuthenticatedKeToanIndexRoute,
  AuthenticatedLeaveTrackingIndexRoute: AuthenticatedLeaveTrackingIndexRoute,
  AuthenticatedNguoiDungIndexRoute: AuthenticatedNguoiDungIndexRoute,
  AuthenticatedNhaMayIndexRoute: AuthenticatedNhaMayIndexRoute,
  AuthenticatedNhanSuIndexRoute: AuthenticatedNhanSuIndexRoute,
  AuthenticatedPayslipDashboardIndexRoute:
    AuthenticatedPayslipDashboardIndexRoute,
  AuthenticatedProfileDashboardIndexRoute:
    AuthenticatedProfileDashboardIndexRoute,
  AuthenticatedRequestTicketIndexRoute: AuthenticatedRequestTicketIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedTimekeepingIndexRoute: AuthenticatedTimekeepingIndexRoute,
  AuthenticatedTransactionCategoryIndexRoute:
    AuthenticatedTransactionCategoryIndexRoute,
  AuthenticatedVaiTroIndexRoute: AuthenticatedVaiTroIndexRoute,
  AuthenticatedWorkforceAnalyticsIndexRoute:
    AuthenticatedWorkforceAnalyticsIndexRoute,
  AuthenticatedWorkforceInsightsIndexRoute:
    AuthenticatedWorkforceInsightsIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof AuthenticatedRouteRouteWithChildren
  '/assets': typeof AuthenticatedAssetsRouteRoute
  '/companies': typeof AuthenticatedCompaniesRouteRouteWithChildren
  '/custom-tag': typeof AuthenticatedCustomTagRouteRoute
  '/employee-assets': typeof AuthenticatedEmployeeAssetsRouteRoute
  '/employee-groups': typeof AuthenticatedEmployeeGroupsRouteRoute
  '/employees': typeof AuthenticatedEmployeesRouteRouteWithChildren
  '/file-storage': typeof AuthenticatedFileStorageRouteRoute
  '/holiday-setting': typeof AuthenticatedHolidaySettingRouteRoute
  '/notifications': typeof AuthenticatedNotificationsRouteRoute
  '/roles': typeof AuthenticatedRolesRouteRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/user-sessions': typeof AuthenticatedUserSessionsRouteRouteWithChildren
  '/users': typeof AuthenticatedUsersRouteRouteWithChildren
  '/dang-nhap': typeof authDangNhapRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/location-required': typeof authLocationRequiredRoute
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/banned-employees': typeof AuthenticatedBannedEmployeesRoute
  '/business-plan-settings': typeof AuthenticatedBusinessPlanSettingsRoute
  '/business-report': typeof AuthenticatedBusinessReportRoute
  '/employee-assets-dashboard': typeof AuthenticatedEmployeeAssetsDashboardRoute
  '/employee-gifts': typeof AuthenticatedEmployeeGiftsRoute
  '/insurance-dashboard': typeof AuthenticatedInsuranceDashboardRoute
  '/labor-contract-dashboard': typeof AuthenticatedLaborContractDashboardRoute
  '/labor-contract-generation': typeof AuthenticatedLaborContractGenerationRoute
  '/labor-contracts': typeof AuthenticatedLaborContractsRoute
  '/skills': typeof AuthenticatedSkillsRoute
  '/user-activity-logs': typeof AuthenticatedUserActivityLogsRoute
  '/payslip-management': typeof AuthenticatedPayslipManagementLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/employees/$id': typeof AuthenticatedEmployeesIdRouteRouteWithChildren
  '/employees/new': typeof AuthenticatedEmployeesNewRouteRoute
  '/employee-portal/attendance': typeof AuthenticatedEmployeePortalAttendanceRoute
  '/employee-portal/consumption': typeof AuthenticatedEmployeePortalConsumptionRoute
  '/employee-portal/contracts': typeof AuthenticatedEmployeePortalContractsRoute
  '/employee-portal/dormitory': typeof AuthenticatedEmployeePortalDormitoryRoute
  '/employee-portal/gifts': typeof AuthenticatedEmployeePortalGiftsRoute
  '/employee-portal/profile': typeof AuthenticatedEmployeePortalProfileRoute
  '/employee-portal/request-tickets': typeof AuthenticatedEmployeePortalRequestTicketsRoute
  '/employee-portal/wallet': typeof AuthenticatedEmployeePortalWalletRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/user-sessions/statistics': typeof AuthenticatedUserSessionsStatisticsRoute
  '/accounting-dashboard': typeof AuthenticatedAccountingDashboardIndexRoute
  '/accounting-transaction': typeof AuthenticatedAccountingTransactionIndexRoute
  '/apps': typeof AuthenticatedAppsIndexRoute
  '/bao-cao': typeof AuthenticatedBaoCaoIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/commission-payslips': typeof AuthenticatedCommissionPayslipsIndexRoute
  '/commission-statistics': typeof AuthenticatedCommissionStatisticsIndexRoute
  '/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/diligent-employees': typeof AuthenticatedDiligentEmployeesIndexRoute
  '/dormitory-hierachy': typeof AuthenticatedDormitoryHierachyIndexRoute
  '/dormitory-management': typeof AuthenticatedDormitoryManagementIndexRoute
  '/employee-portal': typeof AuthenticatedEmployeePortalIndexRoute
  '/employee-wallet': typeof AuthenticatedEmployeeWalletIndexRoute
  '/employees/': typeof AuthenticatedEmployeesIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/ke-toan': typeof AuthenticatedKeToanIndexRoute
  '/leave-tracking': typeof AuthenticatedLeaveTrackingIndexRoute
  '/nguoi-dung': typeof AuthenticatedNguoiDungIndexRoute
  '/nha-may': typeof AuthenticatedNhaMayIndexRoute
  '/nhan-su': typeof AuthenticatedNhanSuIndexRoute
  '/payslip-dashboard': typeof AuthenticatedPayslipDashboardIndexRoute
  '/profile-dashboard': typeof AuthenticatedProfileDashboardIndexRoute
  '/request-ticket': typeof AuthenticatedRequestTicketIndexRoute
  '/roles/': typeof AuthenticatedRolesIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/timekeeping': typeof AuthenticatedTimekeepingIndexRoute
  '/transaction-category': typeof AuthenticatedTransactionCategoryIndexRoute
  '/user-sessions/': typeof AuthenticatedUserSessionsIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/vai-tro': typeof AuthenticatedVaiTroIndexRoute
  '/workforce-analytics': typeof AuthenticatedWorkforceAnalyticsIndexRoute
  '/workforce-insights': typeof AuthenticatedWorkforceInsightsIndexRoute
  '/employees/$id/edit': typeof AuthenticatedEmployeesIdEditRouteRoute
}

export interface FileRoutesByTo {
  '/assets': typeof AuthenticatedAssetsRouteRoute
  '/custom-tag': typeof AuthenticatedCustomTagRouteRoute
  '/employee-assets': typeof AuthenticatedEmployeeAssetsRouteRoute
  '/employee-groups': typeof AuthenticatedEmployeeGroupsRouteRoute
  '/file-storage': typeof AuthenticatedFileStorageRouteRoute
  '/holiday-setting': typeof AuthenticatedHolidaySettingRouteRoute
  '/notifications': typeof AuthenticatedNotificationsRouteRoute
  '/dang-nhap': typeof authDangNhapRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/location-required': typeof authLocationRequiredRoute
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/banned-employees': typeof AuthenticatedBannedEmployeesRoute
  '/business-plan-settings': typeof AuthenticatedBusinessPlanSettingsRoute
  '/business-report': typeof AuthenticatedBusinessReportRoute
  '/employee-assets-dashboard': typeof AuthenticatedEmployeeAssetsDashboardRoute
  '/employee-gifts': typeof AuthenticatedEmployeeGiftsRoute
  '/insurance-dashboard': typeof AuthenticatedInsuranceDashboardRoute
  '/labor-contract-dashboard': typeof AuthenticatedLaborContractDashboardRoute
  '/labor-contract-generation': typeof AuthenticatedLaborContractGenerationRoute
  '/labor-contracts': typeof AuthenticatedLaborContractsRoute
  '/skills': typeof AuthenticatedSkillsRoute
  '/user-activity-logs': typeof AuthenticatedUserActivityLogsRoute
  '/payslip-management': typeof AuthenticatedPayslipManagementLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/employees/$id': typeof AuthenticatedEmployeesIdRouteRouteWithChildren
  '/employees/new': typeof AuthenticatedEmployeesNewRouteRoute
  '/employee-portal/attendance': typeof AuthenticatedEmployeePortalAttendanceRoute
  '/employee-portal/consumption': typeof AuthenticatedEmployeePortalConsumptionRoute
  '/employee-portal/contracts': typeof AuthenticatedEmployeePortalContractsRoute
  '/employee-portal/dormitory': typeof AuthenticatedEmployeePortalDormitoryRoute
  '/employee-portal/gifts': typeof AuthenticatedEmployeePortalGiftsRoute
  '/employee-portal/profile': typeof AuthenticatedEmployeePortalProfileRoute
  '/employee-portal/request-tickets': typeof AuthenticatedEmployeePortalRequestTicketsRoute
  '/employee-portal/wallet': typeof AuthenticatedEmployeePortalWalletRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/user-sessions/statistics': typeof AuthenticatedUserSessionsStatisticsRoute
  '/accounting-dashboard': typeof AuthenticatedAccountingDashboardIndexRoute
  '/accounting-transaction': typeof AuthenticatedAccountingTransactionIndexRoute
  '/apps': typeof AuthenticatedAppsIndexRoute
  '/bao-cao': typeof AuthenticatedBaoCaoIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/commission-payslips': typeof AuthenticatedCommissionPayslipsIndexRoute
  '/commission-statistics': typeof AuthenticatedCommissionStatisticsIndexRoute
  '/companies': typeof AuthenticatedCompaniesIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/diligent-employees': typeof AuthenticatedDiligentEmployeesIndexRoute
  '/dormitory-hierachy': typeof AuthenticatedDormitoryHierachyIndexRoute
  '/dormitory-management': typeof AuthenticatedDormitoryManagementIndexRoute
  '/employee-portal': typeof AuthenticatedEmployeePortalIndexRoute
  '/employee-wallet': typeof AuthenticatedEmployeeWalletIndexRoute
  '/employees': typeof AuthenticatedEmployeesIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/ke-toan': typeof AuthenticatedKeToanIndexRoute
  '/leave-tracking': typeof AuthenticatedLeaveTrackingIndexRoute
  '/nguoi-dung': typeof AuthenticatedNguoiDungIndexRoute
  '/nha-may': typeof AuthenticatedNhaMayIndexRoute
  '/nhan-su': typeof AuthenticatedNhanSuIndexRoute
  '/payslip-dashboard': typeof AuthenticatedPayslipDashboardIndexRoute
  '/profile-dashboard': typeof AuthenticatedProfileDashboardIndexRoute
  '/request-ticket': typeof AuthenticatedRequestTicketIndexRoute
  '/roles': typeof AuthenticatedRolesIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/timekeeping': typeof AuthenticatedTimekeepingIndexRoute
  '/transaction-category': typeof AuthenticatedTransactionCategoryIndexRoute
  '/user-sessions': typeof AuthenticatedUserSessionsIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/vai-tro': typeof AuthenticatedVaiTroIndexRoute
  '/workforce-analytics': typeof AuthenticatedWorkforceAnalyticsIndexRoute
  '/workforce-insights': typeof AuthenticatedWorkforceInsightsIndexRoute
  '/employees/$id/edit': typeof AuthenticatedEmployeesIdEditRouteRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_authenticated/assets': typeof AuthenticatedAssetsRouteRoute
  '/_authenticated/companies': typeof AuthenticatedCompaniesRouteRouteWithChildren
  '/_authenticated/custom-tag': typeof AuthenticatedCustomTagRouteRoute
  '/_authenticated/employee-assets': typeof AuthenticatedEmployeeAssetsRouteRoute
  '/_authenticated/employee-groups': typeof AuthenticatedEmployeeGroupsRouteRoute
  '/_authenticated/employees': typeof AuthenticatedEmployeesRouteRouteWithChildren
  '/_authenticated/file-storage': typeof AuthenticatedFileStorageRouteRoute
  '/_authenticated/holiday-setting': typeof AuthenticatedHolidaySettingRouteRoute
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRouteRoute
  '/_authenticated/roles': typeof AuthenticatedRolesRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/_authenticated/user-sessions': typeof AuthenticatedUserSessionsRouteRouteWithChildren
  '/_authenticated/users': typeof AuthenticatedUsersRouteRouteWithChildren
  '/(auth)/dang-nhap': typeof authDangNhapRoute
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/location-required': typeof authLocationRequiredRoute
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-in-2': typeof authSignIn2Route
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/banned-employees': typeof AuthenticatedBannedEmployeesRoute
  '/_authenticated/business-plan-settings': typeof AuthenticatedBusinessPlanSettingsRoute
  '/_authenticated/business-report': typeof AuthenticatedBusinessReportRoute
  '/_authenticated/employee-assets-dashboard': typeof AuthenticatedEmployeeAssetsDashboardRoute
  '/_authenticated/employee-gifts': typeof AuthenticatedEmployeeGiftsRoute
  '/_authenticated/insurance-dashboard': typeof AuthenticatedInsuranceDashboardRoute
  '/_authenticated/labor-contract-dashboard': typeof AuthenticatedLaborContractDashboardRoute
  '/_authenticated/labor-contract-generation': typeof AuthenticatedLaborContractGenerationRoute
  '/_authenticated/labor-contracts': typeof AuthenticatedLaborContractsRoute
  '/_authenticated/skills': typeof AuthenticatedSkillsRoute
  '/_authenticated/user-activity-logs': typeof AuthenticatedUserActivityLogsRoute
  '/_authenticated/payslip-management': typeof AuthenticatedPayslipManagementLazyRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/employees/$id': typeof AuthenticatedEmployeesIdRouteRouteWithChildren
  '/_authenticated/employees/new': typeof AuthenticatedEmployeesNewRouteRoute
  '/_authenticated/employee-portal/attendance': typeof AuthenticatedEmployeePortalAttendanceRoute
  '/_authenticated/employee-portal/consumption': typeof AuthenticatedEmployeePortalConsumptionRoute
  '/_authenticated/employee-portal/contracts': typeof AuthenticatedEmployeePortalContractsRoute
  '/_authenticated/employee-portal/dormitory': typeof AuthenticatedEmployeePortalDormitoryRoute
  '/_authenticated/employee-portal/gifts': typeof AuthenticatedEmployeePortalGiftsRoute
  '/_authenticated/employee-portal/profile': typeof AuthenticatedEmployeePortalProfileRoute
  '/_authenticated/employee-portal/request-tickets': typeof AuthenticatedEmployeePortalRequestTicketsRoute
  '/_authenticated/employee-portal/wallet': typeof AuthenticatedEmployeePortalWalletRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/_authenticated/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/_authenticated/user-sessions/statistics': typeof AuthenticatedUserSessionsStatisticsRoute
  '/_authenticated/accounting-dashboard/': typeof AuthenticatedAccountingDashboardIndexRoute
  '/_authenticated/accounting-transaction/': typeof AuthenticatedAccountingTransactionIndexRoute
  '/_authenticated/apps/': typeof AuthenticatedAppsIndexRoute
  '/_authenticated/bao-cao/': typeof AuthenticatedBaoCaoIndexRoute
  '/_authenticated/chats/': typeof AuthenticatedChatsIndexRoute
  '/_authenticated/commission-payslips/': typeof AuthenticatedCommissionPayslipsIndexRoute
  '/_authenticated/commission-statistics/': typeof AuthenticatedCommissionStatisticsIndexRoute
  '/_authenticated/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/diligent-employees/': typeof AuthenticatedDiligentEmployeesIndexRoute
  '/_authenticated/dormitory-hierachy/': typeof AuthenticatedDormitoryHierachyIndexRoute
  '/_authenticated/dormitory-management/': typeof AuthenticatedDormitoryManagementIndexRoute
  '/_authenticated/employee-portal/': typeof AuthenticatedEmployeePortalIndexRoute
  '/_authenticated/employee-wallet/': typeof AuthenticatedEmployeeWalletIndexRoute
  '/_authenticated/employees/': typeof AuthenticatedEmployeesIndexRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/_authenticated/ke-toan/': typeof AuthenticatedKeToanIndexRoute
  '/_authenticated/leave-tracking/': typeof AuthenticatedLeaveTrackingIndexRoute
  '/_authenticated/nguoi-dung/': typeof AuthenticatedNguoiDungIndexRoute
  '/_authenticated/nha-may/': typeof AuthenticatedNhaMayIndexRoute
  '/_authenticated/nhan-su/': typeof AuthenticatedNhanSuIndexRoute
  '/_authenticated/payslip-dashboard/': typeof AuthenticatedPayslipDashboardIndexRoute
  '/_authenticated/profile-dashboard/': typeof AuthenticatedProfileDashboardIndexRoute
  '/_authenticated/request-ticket/': typeof AuthenticatedRequestTicketIndexRoute
  '/_authenticated/roles/': typeof AuthenticatedRolesIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/timekeeping/': typeof AuthenticatedTimekeepingIndexRoute
  '/_authenticated/transaction-category/': typeof AuthenticatedTransactionCategoryIndexRoute
  '/_authenticated/user-sessions/': typeof AuthenticatedUserSessionsIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/vai-tro/': typeof AuthenticatedVaiTroIndexRoute
  '/_authenticated/workforce-analytics/': typeof AuthenticatedWorkforceAnalyticsIndexRoute
  '/_authenticated/workforce-insights/': typeof AuthenticatedWorkforceInsightsIndexRoute
  '/_authenticated/employees/$id/edit': typeof AuthenticatedEmployeesIdEditRouteRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/assets'
    | '/companies'
    | '/custom-tag'
    | '/employee-assets'
    | '/employee-groups'
    | '/employees'
    | '/file-storage'
    | '/holiday-setting'
    | '/notifications'
    | '/roles'
    | '/settings'
    | '/user-sessions'
    | '/users'
    | '/dang-nhap'
    | '/forgot-password'
    | '/location-required'
    | '/otp'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/banned-employees'
    | '/business-plan-settings'
    | '/business-report'
    | '/employee-assets-dashboard'
    | '/employee-gifts'
    | '/insurance-dashboard'
    | '/labor-contract-dashboard'
    | '/labor-contract-generation'
    | '/labor-contracts'
    | '/skills'
    | '/user-activity-logs'
    | '/payslip-management'
    | '/'
    | '/employees/$id'
    | '/employees/new'
    | '/employee-portal/attendance'
    | '/employee-portal/consumption'
    | '/employee-portal/contracts'
    | '/employee-portal/dormitory'
    | '/employee-portal/gifts'
    | '/employee-portal/profile'
    | '/employee-portal/request-tickets'
    | '/employee-portal/wallet'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/settings/profile'
    | '/user-sessions/statistics'
    | '/accounting-dashboard'
    | '/accounting-transaction'
    | '/apps'
    | '/bao-cao'
    | '/chats'
    | '/commission-payslips'
    | '/commission-statistics'
    | '/companies/'
    | '/dashboard'
    | '/diligent-employees'
    | '/dormitory-hierachy'
    | '/dormitory-management'
    | '/employee-portal'
    | '/employee-wallet'
    | '/employees/'
    | '/help-center'
    | '/ke-toan'
    | '/leave-tracking'
    | '/nguoi-dung'
    | '/nha-may'
    | '/nhan-su'
    | '/payslip-dashboard'
    | '/profile-dashboard'
    | '/request-ticket'
    | '/roles/'
    | '/settings/'
    | '/tasks'
    | '/timekeeping'
    | '/transaction-category'
    | '/user-sessions/'
    | '/users/'
    | '/vai-tro'
    | '/workforce-analytics'
    | '/workforce-insights'
    | '/employees/$id/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/assets'
    | '/custom-tag'
    | '/employee-assets'
    | '/employee-groups'
    | '/file-storage'
    | '/holiday-setting'
    | '/notifications'
    | '/dang-nhap'
    | '/forgot-password'
    | '/location-required'
    | '/otp'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/banned-employees'
    | '/business-plan-settings'
    | '/business-report'
    | '/employee-assets-dashboard'
    | '/employee-gifts'
    | '/insurance-dashboard'
    | '/labor-contract-dashboard'
    | '/labor-contract-generation'
    | '/labor-contracts'
    | '/skills'
    | '/user-activity-logs'
    | '/payslip-management'
    | '/'
    | '/employees/$id'
    | '/employees/new'
    | '/employee-portal/attendance'
    | '/employee-portal/consumption'
    | '/employee-portal/contracts'
    | '/employee-portal/dormitory'
    | '/employee-portal/gifts'
    | '/employee-portal/profile'
    | '/employee-portal/request-tickets'
    | '/employee-portal/wallet'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/settings/profile'
    | '/user-sessions/statistics'
    | '/accounting-dashboard'
    | '/accounting-transaction'
    | '/apps'
    | '/bao-cao'
    | '/chats'
    | '/commission-payslips'
    | '/commission-statistics'
    | '/companies'
    | '/dashboard'
    | '/diligent-employees'
    | '/dormitory-hierachy'
    | '/dormitory-management'
    | '/employee-portal'
    | '/employee-wallet'
    | '/employees'
    | '/help-center'
    | '/ke-toan'
    | '/leave-tracking'
    | '/nguoi-dung'
    | '/nha-may'
    | '/nhan-su'
    | '/payslip-dashboard'
    | '/profile-dashboard'
    | '/request-ticket'
    | '/roles'
    | '/settings'
    | '/tasks'
    | '/timekeeping'
    | '/transaction-category'
    | '/user-sessions'
    | '/users'
    | '/vai-tro'
    | '/workforce-analytics'
    | '/workforce-insights'
    | '/employees/$id/edit'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/assets'
    | '/_authenticated/companies'
    | '/_authenticated/custom-tag'
    | '/_authenticated/employee-assets'
    | '/_authenticated/employee-groups'
    | '/_authenticated/employees'
    | '/_authenticated/file-storage'
    | '/_authenticated/holiday-setting'
    | '/_authenticated/notifications'
    | '/_authenticated/roles'
    | '/_authenticated/settings'
    | '/_authenticated/user-sessions'
    | '/_authenticated/users'
    | '/(auth)/dang-nhap'
    | '/(auth)/forgot-password'
    | '/(auth)/location-required'
    | '/(auth)/otp'
    | '/(auth)/sign-in'
    | '/(auth)/sign-in-2'
    | '/(auth)/sign-up'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/banned-employees'
    | '/_authenticated/business-plan-settings'
    | '/_authenticated/business-report'
    | '/_authenticated/employee-assets-dashboard'
    | '/_authenticated/employee-gifts'
    | '/_authenticated/insurance-dashboard'
    | '/_authenticated/labor-contract-dashboard'
    | '/_authenticated/labor-contract-generation'
    | '/_authenticated/labor-contracts'
    | '/_authenticated/skills'
    | '/_authenticated/user-activity-logs'
    | '/_authenticated/payslip-management'
    | '/_authenticated/'
    | '/_authenticated/employees/$id'
    | '/_authenticated/employees/new'
    | '/_authenticated/employee-portal/attendance'
    | '/_authenticated/employee-portal/consumption'
    | '/_authenticated/employee-portal/contracts'
    | '/_authenticated/employee-portal/dormitory'
    | '/_authenticated/employee-portal/gifts'
    | '/_authenticated/employee-portal/profile'
    | '/_authenticated/employee-portal/request-tickets'
    | '/_authenticated/employee-portal/wallet'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/display'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/settings/profile'
    | '/_authenticated/user-sessions/statistics'
    | '/_authenticated/accounting-dashboard/'
    | '/_authenticated/accounting-transaction/'
    | '/_authenticated/apps/'
    | '/_authenticated/bao-cao/'
    | '/_authenticated/chats/'
    | '/_authenticated/commission-payslips/'
    | '/_authenticated/commission-statistics/'
    | '/_authenticated/companies/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/diligent-employees/'
    | '/_authenticated/dormitory-hierachy/'
    | '/_authenticated/dormitory-management/'
    | '/_authenticated/employee-portal/'
    | '/_authenticated/employee-wallet/'
    | '/_authenticated/employees/'
    | '/_authenticated/help-center/'
    | '/_authenticated/ke-toan/'
    | '/_authenticated/leave-tracking/'
    | '/_authenticated/nguoi-dung/'
    | '/_authenticated/nha-may/'
    | '/_authenticated/nhan-su/'
    | '/_authenticated/payslip-dashboard/'
    | '/_authenticated/profile-dashboard/'
    | '/_authenticated/request-ticket/'
    | '/_authenticated/roles/'
    | '/_authenticated/settings/'
    | '/_authenticated/tasks/'
    | '/_authenticated/timekeeping/'
    | '/_authenticated/transaction-category/'
    | '/_authenticated/user-sessions/'
    | '/_authenticated/users/'
    | '/_authenticated/vai-tro/'
    | '/_authenticated/workforce-analytics/'
    | '/_authenticated/workforce-insights/'
    | '/_authenticated/employees/$id/edit'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  authDangNhapRoute: typeof authDangNhapRoute
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authLocationRequiredRoute: typeof authLocationRequiredRoute
  authOtpRoute: typeof authOtpRoute
  authSignInRoute: typeof authSignInRoute
  authSignIn2Route: typeof authSignIn2Route
  authSignUpRoute: typeof authSignUpRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  authDangNhapRoute: authDangNhapRoute,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authLocationRequiredRoute: authLocationRequiredRoute,
  authOtpRoute: authOtpRoute,
  authSignInRoute: authSignInRoute,
  authSignIn2Route: authSignIn2Route,
  authSignUpRoute: authSignUpRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/(auth)/dang-nhap",
        "/(auth)/forgot-password",
        "/(auth)/location-required",
        "/(auth)/otp",
        "/(auth)/sign-in",
        "/(auth)/sign-in-2",
        "/(auth)/sign-up",
        "/(errors)/401",
        "/(errors)/403",
        "/(errors)/404",
        "/(errors)/500",
        "/(errors)/503"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated/route.tsx",
      "children": [
        "/_authenticated/assets",
        "/_authenticated/companies",
        "/_authenticated/custom-tag",
        "/_authenticated/employee-assets",
        "/_authenticated/employee-groups",
        "/_authenticated/employees",
        "/_authenticated/file-storage",
        "/_authenticated/holiday-setting",
        "/_authenticated/notifications",
        "/_authenticated/roles",
        "/_authenticated/settings",
        "/_authenticated/user-sessions",
        "/_authenticated/users",
        "/_authenticated/banned-employees",
        "/_authenticated/business-plan-settings",
        "/_authenticated/business-report",
        "/_authenticated/employee-assets-dashboard",
        "/_authenticated/employee-gifts",
        "/_authenticated/insurance-dashboard",
        "/_authenticated/labor-contract-dashboard",
        "/_authenticated/labor-contract-generation",
        "/_authenticated/labor-contracts",
        "/_authenticated/skills",
        "/_authenticated/user-activity-logs",
        "/_authenticated/payslip-management",
        "/_authenticated/",
        "/_authenticated/employee-portal/attendance",
        "/_authenticated/employee-portal/consumption",
        "/_authenticated/employee-portal/contracts",
        "/_authenticated/employee-portal/dormitory",
        "/_authenticated/employee-portal/gifts",
        "/_authenticated/employee-portal/profile",
        "/_authenticated/employee-portal/request-tickets",
        "/_authenticated/employee-portal/wallet",
        "/_authenticated/accounting-dashboard/",
        "/_authenticated/accounting-transaction/",
        "/_authenticated/apps/",
        "/_authenticated/bao-cao/",
        "/_authenticated/chats/",
        "/_authenticated/commission-payslips/",
        "/_authenticated/commission-statistics/",
        "/_authenticated/dashboard/",
        "/_authenticated/diligent-employees/",
        "/_authenticated/dormitory-hierachy/",
        "/_authenticated/dormitory-management/",
        "/_authenticated/employee-portal/",
        "/_authenticated/employee-wallet/",
        "/_authenticated/help-center/",
        "/_authenticated/ke-toan/",
        "/_authenticated/leave-tracking/",
        "/_authenticated/nguoi-dung/",
        "/_authenticated/nha-may/",
        "/_authenticated/nhan-su/",
        "/_authenticated/payslip-dashboard/",
        "/_authenticated/profile-dashboard/",
        "/_authenticated/request-ticket/",
        "/_authenticated/tasks/",
        "/_authenticated/timekeeping/",
        "/_authenticated/transaction-category/",
        "/_authenticated/vai-tro/",
        "/_authenticated/workforce-analytics/",
        "/_authenticated/workforce-insights/"
      ]
    },
    "/_authenticated/assets": {
      "filePath": "_authenticated/assets/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/companies": {
      "filePath": "_authenticated/companies/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/companies/"
      ]
    },
    "/_authenticated/custom-tag": {
      "filePath": "_authenticated/custom-tag/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/employee-assets": {
      "filePath": "_authenticated/employee-assets/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/employee-groups": {
      "filePath": "_authenticated/employee-groups/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/employees": {
      "filePath": "_authenticated/employees/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/employees/$id",
        "/_authenticated/employees/new",
        "/_authenticated/employees/"
      ]
    },
    "/_authenticated/file-storage": {
      "filePath": "_authenticated/file-storage/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/holiday-setting": {
      "filePath": "_authenticated/holiday-setting/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/notifications": {
      "filePath": "_authenticated/notifications/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/roles": {
      "filePath": "_authenticated/roles/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/roles/"
      ]
    },
    "/_authenticated/settings": {
      "filePath": "_authenticated/settings/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/settings/account",
        "/_authenticated/settings/appearance",
        "/_authenticated/settings/display",
        "/_authenticated/settings/notifications",
        "/_authenticated/settings/profile",
        "/_authenticated/settings/"
      ]
    },
    "/_authenticated/user-sessions": {
      "filePath": "_authenticated/user-sessions/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/user-sessions/statistics",
        "/_authenticated/user-sessions/"
      ]
    },
    "/_authenticated/users": {
      "filePath": "_authenticated/users/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/users/"
      ]
    },
    "/(auth)/dang-nhap": {
      "filePath": "(auth)/dang-nhap.tsx"
    },
    "/(auth)/forgot-password": {
      "filePath": "(auth)/forgot-password.tsx"
    },
    "/(auth)/location-required": {
      "filePath": "(auth)/location-required.tsx"
    },
    "/(auth)/otp": {
      "filePath": "(auth)/otp.tsx"
    },
    "/(auth)/sign-in": {
      "filePath": "(auth)/sign-in.tsx"
    },
    "/(auth)/sign-in-2": {
      "filePath": "(auth)/sign-in-2.tsx"
    },
    "/(auth)/sign-up": {
      "filePath": "(auth)/sign-up.tsx"
    },
    "/(errors)/401": {
      "filePath": "(errors)/401.tsx"
    },
    "/(errors)/403": {
      "filePath": "(errors)/403.tsx"
    },
    "/(errors)/404": {
      "filePath": "(errors)/404.tsx"
    },
    "/(errors)/500": {
      "filePath": "(errors)/500.tsx"
    },
    "/(errors)/503": {
      "filePath": "(errors)/503.tsx"
    },
    "/_authenticated/banned-employees": {
      "filePath": "_authenticated/banned-employees.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/business-plan-settings": {
      "filePath": "_authenticated/business-plan-settings.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/business-report": {
      "filePath": "_authenticated/business-report.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/employee-assets-dashboard": {
      "filePath": "_authenticated/employee-assets-dashboard.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/employee-gifts": {
      "filePath": "_authenticated/employee-gifts.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/insurance-dashboard": {
      "filePath": "_authenticated/insurance-dashboard.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/labor-contract-dashboard": {
      "filePath": "_authenticated/labor-contract-dashboard.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/labor-contract-generation": {
      "filePath": "_authenticated/labor-contract-generation.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/labor-contracts": {
      "filePath": "_authenticated/labor-contracts.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/skills": {
      "filePath": "_authenticated/skills.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/user-activity-logs": {
      "filePath": "_authenticated/user-activity-logs.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/payslip-management": {
      "filePath": "_authenticated/payslip-management.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/": {
      "filePath": "_authenticated/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/employees/$id": {
      "filePath": "_authenticated/employees/$id/route.tsx",
      "parent": "/_authenticated/employees",
      "children": [
        "/_authenticated/employees/$id/edit"
      ]
    },
    "/_authenticated/employees/new": {
      "filePath": "_authenticated/employees/new/route.tsx",
      "parent": "/_authenticated/employees"
    },
    "/_authenticated/employee-portal/attendance": {
      "filePath": "_authenticated/employee-portal/attendance.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/employee-portal/consumption": {
      "filePath": "_authenticated/employee-portal/consumption.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/employee-portal/contracts": {
      "filePath": "_authenticated/employee-portal/contracts.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/employee-portal/dormitory": {
      "filePath": "_authenticated/employee-portal/dormitory.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/employee-portal/gifts": {
      "filePath": "_authenticated/employee-portal/gifts.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/employee-portal/profile": {
      "filePath": "_authenticated/employee-portal/profile.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/employee-portal/request-tickets": {
      "filePath": "_authenticated/employee-portal/request-tickets.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/employee-portal/wallet": {
      "filePath": "_authenticated/employee-portal/wallet.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings/account": {
      "filePath": "_authenticated/settings/account.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/appearance": {
      "filePath": "_authenticated/settings/appearance.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/display": {
      "filePath": "_authenticated/settings/display.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/notifications": {
      "filePath": "_authenticated/settings/notifications.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/profile": {
      "filePath": "_authenticated/settings/profile.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/user-sessions/statistics": {
      "filePath": "_authenticated/user-sessions/statistics.tsx",
      "parent": "/_authenticated/user-sessions"
    },
    "/_authenticated/accounting-dashboard/": {
      "filePath": "_authenticated/accounting-dashboard/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/accounting-transaction/": {
      "filePath": "_authenticated/accounting-transaction/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/apps/": {
      "filePath": "_authenticated/apps/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/bao-cao/": {
      "filePath": "_authenticated/bao-cao/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/chats/": {
      "filePath": "_authenticated/chats/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/commission-payslips/": {
      "filePath": "_authenticated/commission-payslips/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/commission-statistics/": {
      "filePath": "_authenticated/commission-statistics/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/companies/": {
      "filePath": "_authenticated/companies/index.tsx",
      "parent": "/_authenticated/companies"
    },
    "/_authenticated/dashboard/": {
      "filePath": "_authenticated/dashboard/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/diligent-employees/": {
      "filePath": "_authenticated/diligent-employees/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/dormitory-hierachy/": {
      "filePath": "_authenticated/dormitory-hierachy/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/dormitory-management/": {
      "filePath": "_authenticated/dormitory-management/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/employee-portal/": {
      "filePath": "_authenticated/employee-portal/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/employee-wallet/": {
      "filePath": "_authenticated/employee-wallet/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/employees/": {
      "filePath": "_authenticated/employees/index.tsx",
      "parent": "/_authenticated/employees"
    },
    "/_authenticated/help-center/": {
      "filePath": "_authenticated/help-center/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/ke-toan/": {
      "filePath": "_authenticated/ke-toan/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/leave-tracking/": {
      "filePath": "_authenticated/leave-tracking/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/nguoi-dung/": {
      "filePath": "_authenticated/nguoi-dung/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/nha-may/": {
      "filePath": "_authenticated/nha-may/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/nhan-su/": {
      "filePath": "_authenticated/nhan-su/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/payslip-dashboard/": {
      "filePath": "_authenticated/payslip-dashboard/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/profile-dashboard/": {
      "filePath": "_authenticated/profile-dashboard/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/request-ticket/": {
      "filePath": "_authenticated/request-ticket/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/roles/": {
      "filePath": "_authenticated/roles/index.tsx",
      "parent": "/_authenticated/roles"
    },
    "/_authenticated/settings/": {
      "filePath": "_authenticated/settings/index.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/tasks/": {
      "filePath": "_authenticated/tasks/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/timekeeping/": {
      "filePath": "_authenticated/timekeeping/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/transaction-category/": {
      "filePath": "_authenticated/transaction-category/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/user-sessions/": {
      "filePath": "_authenticated/user-sessions/index.tsx",
      "parent": "/_authenticated/user-sessions"
    },
    "/_authenticated/users/": {
      "filePath": "_authenticated/users/index.tsx",
      "parent": "/_authenticated/users"
    },
    "/_authenticated/vai-tro/": {
      "filePath": "_authenticated/vai-tro/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/workforce-analytics/": {
      "filePath": "_authenticated/workforce-analytics/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/workforce-insights/": {
      "filePath": "_authenticated/workforce-insights/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/employees/$id/edit": {
      "filePath": "_authenticated/employees/$id/edit/route.tsx",
      "parent": "/_authenticated/employees/$id"
    }
  }
}
ROUTE_MANIFEST_END */
